import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEn from "./en/commonEn";
import commonFil from "./fil/commonFil";
import userManagementEn from "./en/userManagementEn";
import userManagementFil from "./fil/userManagementFil";
import settingsEn from "./en/settingsEn";
// import settingsFil from "./fil/settingsFil";
import masterEn from "./en/masterEn";
import assetsEn from "./en/assetsEn";
import maintenanceEn from "./en/maintenanceEn";
import superAdminEn from "./en/superAdminEn";
import customerFreelancerLinkEn from "./en/customerFreelancerLinkEn";

const resources = {
    en: {
        translation: {
            ...commonEn,
            ...userManagementEn,
            ...settingsEn,
            ...masterEn,
            ...assetsEn,
            ...maintenanceEn,
            ...superAdminEn,
            ...customerFreelancerLinkEn,
        }
    },
    fil: {
        translation: {
            ...commonFil,
            ...userManagementFil,
            // ...settingsFil,
        }
    }
};

// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});

export default i18n;